import React from 'react';
import ReactDOM from 'react-dom/client';
import RendererOnlyApp, { RendererRequest } from './RendererOnlyApp';

export function init() {
    const triggerButton = document.querySelector('.btn-osica-launch-dynamic-deck-image-renderer');
    if (!triggerButton) {
        //Ignore page if not found trigger.
        return;
    }

    // Handle trigger button event.
    document.addEventListener('click', (event) => {
        if (event.target instanceof HTMLElement
            && event.target.classList.contains('btn-osica-launch-dynamic-deck-image-renderer')
            && event.target.hasAttribute('data-osica-deck')) {

            const deckText = event.target.getAttribute('data-osica-deck') ?? '';
            const fileName = event.target.getAttribute('data-osica-file-name') ?? '';
            const line1Text = event.target.getAttribute('data-osica-line-1') ?? '';
            const line2Text = event.target.getAttribute('data-osica-line-2') ?? '';
            const eventDetail: RendererRequest = {
                deckText: deckText,
                fileName: fileName,
                line1Text: line1Text,
                line2Text: line2Text
            };
            window.dispatchEvent(
                new CustomEvent('osicarenderdeck', { detail: eventDetail })
            );
        }
    });

    //Handle SVG Export events.
    window.addEventListener('osicastartrenderer', () => {
        document.querySelectorAll('.btn-osica-launch-dynamic-deck-image-renderer').forEach(item => {
            if (item instanceof HTMLButtonElement) {
                item.disabled = true;
            }
        });
    });
    window.addEventListener('osicarendererexported', () => {
        document.querySelectorAll('.btn-osica-launch-dynamic-deck-image-renderer').forEach(item => {
            if (item instanceof HTMLButtonElement) {
                item.disabled = false;
            }
        });
    });


    // Setup renderer root.
    const rootElement = document.createElement('div');
    rootElement.classList.add('osica-dynamic-deck-image-renderer-root');
    rootElement.style.position = "fixed";
    rootElement.style.left = "0";
    rootElement.style.right = "0";
    rootElement.style.bottom = "0";
    rootElement.style.zIndex = "-1";
    document.body.appendChild(rootElement);
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <RendererOnlyApp />
        </React.StrictMode>
    );
}